import { GroupContacts } from '@/components/contactList/ContactList'
import { profilesStore } from '@/store/profiles/profiles.store'
import { ProfileModel } from '@/types/models/profile'
import { Company } from '@roolz/types/api/companies'
import { Profile, ContactInfo } from '@roolz/types/api/profiles'
import { makeAutoObservable } from 'mobx'

export type ProfileIds = Profile['id'][]

class ContactListStore {
  isLoading = false

  // groups: GroupContacts = {}

  invited: Record<string, Profile> = {}

  private _search = ''

  constructor() {
    makeAutoObservable(this)
  }

  get search(): string {
    return <string>this._search
  }

  set search(value: string) {
    this._search = value
  }

  addInvited(user: Profile) {
    this.invited[user.id] = user
  }

  get personalContacts() {
    return Object.values(profilesStore.profiles)
      .filter(({ relationships }) => relationships?.is_personal_contact
        && !relationships?.is_banned
        && !relationships?.is_banned_me)
  }

  get contactsByCompanies(): Record<Company["id"], ProfileModel[]> {
    if(!profilesStore.my_profile.companies) {
      return {}
    }

    return Object.fromEntries(
      profilesStore.my_profile.companies.map(company => {
        const contacts = Object.values(profilesStore.profiles)
          .filter(({ companies, id }) =>
            !!companies?.length
            && id !== profilesStore.my_profile?.id
            && companies.find(({ id }) => id === company.id)
          )

        return [company.id, contacts]
      })
    )
  }

  get bannedProfiles() {
    return Object.values(profilesStore.profiles)
      .filter(({ relationships }) => relationships?.is_banned && !relationships.is_colleague)
  }
}

const contactListStore = new ContactListStore()

export {
  contactListStore
}
